import { Component, Inject, OnInit , ViewContainerRef} from '@angular/core';
import {UserService} from '../../../../../services/users-service/user-service';
import {ActivatedRoute, Router} from '@angular/router';
import {AnonymousService} from '../../../../../services/anonymous-service';
import {SharedService} from '../../../../../services/shared-service/shared.service';
import {Constants} from '../../../../../util/Constants';
import {MD_DIALOG_DATA, MdCheckbox, MdDialog, MdDialogRef, MdSnackBar} from '@angular/material';
import {ToastService} from '../../../../../util/toast-service/toast.service';
import {ErrorService} from '../../../../../util/error_service/error.service';
import '../../../../../util/custom-alert/custom-alert.component';
import {MobileNetworks} from '../../../../../util/mobile-networks';
import {AgentNetworkConfig} from '../../../../../util/models/network/agent-network-config.model';

@Component({
  selector: 'app-agent-profile',
  templateUrl: './agent-account.component.html',
  styleUrls: ['./agent-account.component.scss']
})
export class AgentProfileComponent implements OnInit {
  type: string;

  public isEdit: boolean;
  public viewInfo: boolean;
  public switchCreate: boolean;
  public roles: any;
  public userDataResponse: any;
  public error: any;
  public message: any;
  public isNotEdit: boolean;
  public edit_text: string;
  public isloading: boolean;
  public pageTitle: string;
  public recentAgentTransactions : any;
  public isLoadingrecentTransactions : boolean;
  public errorResponse: any;
  public userData: any;
  public blockingText: string;
  public userId: number;
  public isBlocked: any;
  public networksLogoPath : any = [];
  public networkObj: any;
  public activeId : number;
  public agentCommission : number;
  public isConfigSaving : boolean;

  public airtimeNetworkConfig = [];
  public airtimeNetworkConfigWithId = [];
  public isLoadingAirtimeNetworkConfig: boolean;

  public dataNetworkConfig = [];
  public dataNetworkConfigWithId = [];
  public isLoadingDataNetworkConfig: boolean;

  p = 1;
  public networksWithId = [];


  public setId = null;
  public isActive: boolean;

  public allLoading: any = {
    profile: true,
    transaction: true,
    roles: true
  };


  public userFormData: any = {
    roleId: '',
    mainWallet: '',
    commissionWallet: '',
    dateCreated: '',
    lastLogin: '',
    lastName: '',
    firstName: '',
    mobileNo: '',
    altMobileNo: '',
    email: '',
    address: '',
    blocked: ''
  };


  constructor(public _sharedService: SharedService, public router: Router, public anonymousService: AnonymousService, public errorHandler: ErrorService,
              public agentService: UserService, public toast: ToastService, public activatedRoute: ActivatedRoute,public dialog: MdDialog) {
        this.activatedRoute.parent.params.subscribe(params => { this.userId = +params['id'];})
    this.isLoadingAirtimeNetworkConfig = false;
    this.isLoadingDataNetworkConfig = false;

    this.pageTitle = 'Agent Account';

    this.userFormData.mainWallet = 0;
    this.userFormData.commissionWallet = 0;
    this.recentAgentTransactions = [];

    this.airtimeNetworkConfig = [];
    this.dataNetworkConfig = []

    this.networksLogoPath = MobileNetworks.networksLogoPath;

    this.isloading = false;
    this.isLoadingrecentTransactions = true;
    this.getRoles();
    this._sharedService.emitChange(this.pageTitle);
    this.switchCreate = true;

    // Inverted the block logic to make colored button signify active //////////////////////////////
    this.isEdit = false;
    this.getRoles();
    this.isNotEdit = true;
    this.edit_text = 'Edit Profile';
    this.viewInfo = true;
    this.getUser();
    this.activeId = null;
    this.isConfigSaving = false;

  }

  ngOnInit() {
    this.getRecentTransactions();
    this.getAirtimeNetworkConfig(true);
    this.getDataNetworkConfig(true);
  }

  // get network details
  getNetworkDetails(networkObj : any, type: string): number {
    console.log('networkObj', networkObj);
    this.setId = networkObj.id;
    this.isActive = networkObj.status;
    this.networkObj = networkObj;
    this.type = type.toUpperCase();
    return this.setId;
  }


  //  Initialize form //////////////////////////////////////////
  public initializeForm() {
    const formData = this.userFormData;

    const profile = this.userData;
    formData.roleId = profile.role.id;
    formData.mainWallet = profile.walletBalance;
    formData.commissionWallet = profile.walletCommissionBalance;
    formData.dateCreated = profile.createdDate;
    formData.lastLogin = profile.lastLoginDate;
    formData.firstName = profile.firstName;
    formData.lastName = profile.lastName;
    formData.mobileNo = profile.mobile;
    formData.altMobileNo = profile.altMobileNo;
    formData.email = profile.email;
    formData.address = profile.address;
    formData.blocked = profile.disabled;
  }

  onSubmit() {
    this.updateUser();
  }

  // update users
  updateUser = () => {
    this.isloading = true;
    this.agentService.updateAgent(this.userFormData, this.userId).subscribe(
      data => {
        console.log(data);
        if (data.status == 200) {
          this.userDataResponse = data;
          this.message = 'Agent\'s Profile updated successfully';
          this.toast.showSuccess(this.message, 'Success');
        }
        this.isloading = false;
        this.isNotEdit = true;
      },
      err => {
        console.log(err);
        const error = this.error.errorHandlerWithText(this.updateUser, err).message;
        console.log("******* Error *******");
        console.log(error);
        this.isloading = false;
        this.isNotEdit = false;
      }
    )
  }

  // get roles
  getRoles() {
    this.anonymousService.getRoles().subscribe(
      response => {
        // console.log("get roles function");
        // console.log(response.data);
        this.roles = response.data;

        this.allLoading.roles = false;
      },
      err => {
        const errMsg = this.error.errorHandlerWithText(this.getRoles, err);
        // console.log(errMsg.message);
      }
    )
  }

  public getRecentTransactions() {
    this.anonymousService.getUserTransactions(this.userId).subscribe(
      response => {
        // console.log("get user tranx");
        this.recentAgentTransactions = response.data[0].content;
        // console.log('******************* ******************************');
        // console.log(this.recentAgentTransactions);
        this.isLoadingrecentTransactions = false;

        this.allLoading.transaction = false;
      },
      err => {
        // console.log(err);
        this.isLoadingrecentTransactions = false;
        this.errorResponse = this.error.errorHandlerWithText(this.getRecentTransactions, err);
      }
    )
  }

  ////////////////// get airtime networks config ////////////////////////////////////////////////////
  getAirtimeNetworkConfig = (newLoad = false) => {
    if (newLoad) {
      this.isLoadingAirtimeNetworkConfig = true;
    } else {
      this.isLoadingAirtimeNetworkConfig = false;
    }

    this.agentService.getUserAirtimeNetworkConfig(this.userId).subscribe(
      response => {
        this.airtimeNetworkConfig = [];
        //console.log('************ Airtime network list ****************');
        response.data.forEach(network => {
          const dAirtimeNetwork = new AgentNetworkConfig(network);
          this.airtimeNetworkConfig.push(dAirtimeNetwork);
        });

        this.isloading = false;


        //console.log(this.airtimeNetworkConfig);

        /* filter the network */
        this.airtimeNetworkConfigWithId = [];

        this.airtimeNetworkConfig.sort(function(a, b) {
          return ( a.network.id - b.network.id  ||  a.network.networkName.localeCompare(b.network.networkName) );
        });

        for (let i = 0; i < this.airtimeNetworkConfig.length; i++ ) {
          const sortedNetworks: any = {id: 0, logoPath: '', data: {}};
          sortedNetworks.id = i + 1;
          sortedNetworks.logoPath = this.networksLogoPath[this.airtimeNetworkConfig[i].network['networkCodeName']];
          sortedNetworks.data = this.airtimeNetworkConfig[i];
          this.airtimeNetworkConfigWithId.push(sortedNetworks);
          this.isLoadingAirtimeNetworkConfig = false;
        }
        //console.log('************  Airtime network  with id ****************');
        //console.log(this.airtimeNetworkConfigWithId);
      },
      err => {
        //console.log(err);
        this.errorResponse = this.error.errorHandlerWithText(this.getAirtimeNetworkConfig, err);
        this.isLoadingAirtimeNetworkConfig = false;
       // console.log(this.errorResponse);

      }
    )
  }


  ////////////////// get data networks config ////////////////////////////////////////////////////
  getDataNetworkConfig = (newLoad = false) => {
    if (newLoad) {
      this.isLoadingDataNetworkConfig = true;
    } else {
      this.isLoadingDataNetworkConfig = false;
    }

    this.agentService.getUserDataNetworkConfig(this.userId).subscribe(
      response => {
        this.dataNetworkConfig = [];
        console.log('************ Airtime network list ****************');
        response.data.forEach(network => {
          const dAirtimeNetwork = new AgentNetworkConfig(network);
          this.dataNetworkConfig.push(dAirtimeNetwork);
        });

        this.isloading = false;


        //console.log(this.dataNetworkConfig);

        /* filter the network */
        this.dataNetworkConfigWithId = [];

        this.dataNetworkConfig.sort(function(a, b) {
          return ( a.network.id - b.network.id  ||  a.network.networkName.localeCompare(b.network.networkName) );
        });

        for (let i = 0; i < this.dataNetworkConfig.length; i++ ) {
          const sortedNetworks: any = {id: 0, logoPath: '', data: {}};
          sortedNetworks.id = i + 1;
          sortedNetworks.logoPath = this.networksLogoPath[this.dataNetworkConfig[i].network['networkCodeName']];
          sortedNetworks.data = this.dataNetworkConfig[i];
          this.dataNetworkConfigWithId.push(sortedNetworks);
          this.isLoadingDataNetworkConfig = false;
        }
       // console.log('************  Data network  with id ****************');
       // console.log(this.dataNetworkConfigWithId);
      },
      err => {
        //console.log(err);
        const error = this.error.errorHandlerWithText(this.getDataNetworkConfig, err).message;
        this.isLoadingDataNetworkConfig = false;
        this.toast.showError(error,'Error');
        //console.log(this.errorResponse);

      }
    )
  }


  // public saveNetworkConfig(userid: number, networkId: number, agentCommission:number){
  //     // console.log(" user details : "+userid+" "+networkId+" "+agentCommission);
  //     const networkDataObj = {
  //       'agentCommission' : agentCommission,
  //       'networkId' : networkId,
  //       'userId' : userid
  //     }
  //     this.isConfigSaving = true;
  //
  //   this.agentService.updateNetworkConfig(networkDataObj).subscribe(
  //     response => {
  //       // console.log("commission updated", response.data);
  //         this.getAgentNetworksConfig(false);
  //         this.toast.showSuccess('Agent commission updated', 'Success');
  //         this.isConfigSaving = false;
  //         this.activeId = null;
  //     },
  //     err => {
  //       this.error = this.errorHandler.errorHandlerWithText(this.saveNetworkConfig, err);
  //       this.error = this.error.message;
  //     }
  //   )
  // }


  public resetUserAirtimeNetwork = () => {
    this.agentService.deleteUserAirtimeNetworkConfig(this.networkObj.network.id).subscribe(
      response => {
        this.getAirtimeNetworkConfig(false);
        this.toast.showSuccess('Agent\'s  commission was reset to default', 'Success');
      },
      err => {
        const error = this.error.errorHandlerWithText(this.resetUserAirtimeNetwork, err).message;

        this.toast.showError(error, 'Error');
      }
    )
  }

  public resetUserDataNetwork = () => {
    this.agentService.deleteUserDataNetworkConfig(this.networkObj.network.id).subscribe(
      response => {
        this.getDataNetworkConfig(false);
        this.toast.showSuccess('Agent\'s commission was reset to default', 'Success');
      },
      err => {
        const error = this.error.errorHandlerWithText(this.resetUserDataNetwork, err).message;

        this.toast.showError(error, 'Error');
      }
    )
  }

  configureDialog() {

    const networkData = this.networkObj;

    const dialogRef = this.dialog.open(AgentDialogComponent,{
      height: '300px',
      width: '400px',
      data: {
        networkId : networkData.network.id,
        type : this.type,
        userId : this.userId,
        networkName : networkData.network.networkName,
        swiftaCommission: networkData.swiftaCommission,
        agentCommission: networkData.agentCommission,
        systemCommission: networkData.systemCommission
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result == 'close'){
        return false;
      }
      //console.log('result', result);
      this.toast.showSuccess(result.networkName+ ' commission updated', 'Network Updated');
      if(this.type == 'AIRTIME'){
        this.getAirtimeNetworkConfig(false);
      }else{
        this.getDataNetworkConfig(false);
      }
    });

  }


  public getUser = () => {
    this.anonymousService.getUser(this.userId).subscribe(
      response => {
        //console.log("get user function");
        this.userData = response.data[0];
       // console.log(this.userData);

        this.allLoading.profile = false;

        this.initializeForm();
        // console.log('******************* ******************************');
        // console.log(this.userData);
        // console.log(this.userFormData.blocked);

        if (this.userFormData.blocked) {
          this.isBlocked = false;
          this.blockingText = 'Blocked';
        } else {
          this.isBlocked = true;
          this.blockingText = 'Unblocked';
        }
        // console.log(this.userFormData);
      },
      err => {
        this.error.errorHandlerWithText(this.getUser, err);
        // console.log(errMsg.message);
      }
    )
  }

  editProfile() {
    if (this.isNotEdit) {
      this.isNotEdit = false;
    } else {
      this.isNotEdit = true;
    }
  }
}

@Component({
  selector: 'dialog-result',
  styles: [ '.user-details { margin-bottom: 5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: center;}',
    '.user-details span{ color:#444; text-transform:uppercase; text-overflow:ellipsis}',
    '.wallet { font-weight: normal; padding:2px 5px; border-radius:5px;text-align: center;} background-color:#ededed; display: inline-block;} '],
  templateUrl: 'network-dialog.html',
})


export class AgentDialogComponent {
  systemCommission: any;
  swiftaCommission: any;
  agentCommission: any;
  networkName: any;
  networkId: any;
  type : string;
  userId : number;


  public amount : number;
  public isUpdating : boolean;


  constructor(
    public dialogRef: MdDialogRef<AgentDialogComponent>, private userService: UserService, private error: ErrorService,
    @Inject(MD_DIALOG_DATA) public data: any) {
    // console.log('data', this.data);

    this.networkId = this.data.networkId;
    this.agentCommission = this.data.agentCommission;
    this.systemCommission = this.data.systemCommission;
    this.networkName = this.data.networkName;
    this.isUpdating = false;
    this.type = this.data.type
    this.userId = this.data.userId;
  }


  updateNetwork = () => {

    // const networkData = {
    //   'agentCommission': this.agentCommission,
    //   'networkName': this.swiftaCommission,
    //   'systemCommission': this.systemCommission
    // }

    const configData = {
      'agentCommission': this.agentCommission,
      'networkId': this.networkId,
      'userId': this.userId
    }

    const configMessage = {updated: false, networkName : ''} ;
    this.isUpdating = true;

    if(this.type == 'AIRTIME'){
      this.userService.createUserAirtimeNetworkConfig(configData).subscribe(
        data => {
          // console.log('data from network', data);
          configMessage.updated = true;
          configMessage.networkName = this.networkName;
          this.isUpdating = false;

          this.dialogRef.close(configMessage);
        },
        err => {
          console.log(err);
          const msg = this.error.errorHandlerWithText(this.updateNetwork, err);
        }
      )
    }
    else if(this.type == 'DATA'){
      this.userService.createUserDataNetworkConfig(configData).subscribe(
        data => {
          console.log('data from network', data);
          configMessage.updated = true;
          configMessage.networkName = this.networkName;
          this.isUpdating = false;

          this.dialogRef.close(configMessage);
        },
        err => {
          console.log(err);
          const msg = this.error.errorHandlerWithText(this.updateNetwork, err);
        }
      )
    }
  }



}




// WEBPACK FOOTER //
// ./src/app/Dashboard/DashboardPages/User management/user-page/agent-account/agent-account.component.ts